import { createInstance, OptimizelyProvider as Optimizely, setLogger } from '@optimizely/react-sdk'
import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import isBrowser from 'utils/isBrowser'
import getConfig from 'next/config'

const OptimizelyProvider = ({ children }) => {
  const [optimizelyInitialized, setOptimizelyInitialized] = useState(false)
  const { sessionId, attributes, loggerEnabled } = useSelector((state) => state.optimizely)
  const optimizelyInstance = useRef()
  const isServerSide = !isBrowser()

  if (!loggerEnabled) {
    setLogger(null)
  }

  const { publicRuntimeConfig } = getConfig()
  useEffect(() => {
    if (!optimizelyInstance.current) {
      optimizelyInstance.current = createInstance({
        sdkKey: publicRuntimeConfig.OPTIMIZELY_SDK_KEY,
        datafileOptions: {
          autoUpdate: true,
          updateInterval: 60000, // 1min
        },
      })
      setOptimizelyInitialized(true)
    }
  }, [publicRuntimeConfig])

  if (!optimizelyInitialized) {
    return null
  }

  return (
    <Optimizely
      optimizely={optimizelyInstance.current}
      user={{
        id: sessionId,
        attributes,
      }}
      isServerSide={isServerSide}
    >
      {children}
    </Optimizely>
  )
}

export default OptimizelyProvider
